var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero",attrs:{"id":"home"}},[_c('div',{staticClass:"hero-image wrapper"},[_c('stars'),_vm._v(" "),_c('rainbow'),_vm._v(" "),_c('clouds'),_vm._v(" "),_c('img',{staticClass:"icon",attrs:{"src":require("../../assets/unicorn.svg")}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }